module.exports = __webpack_public_path__ + "img/26cad-contact_b.bcda2f84.jpg";